module.exports = "/_next/static/images/4cdc47bbd840c54e52d1a34b3f756d6f-dress-code-1.png.webp";